var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddCircleOutlineGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / add-circle-outline") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8,4.66666667 C7.63333333,4.66666667 7.33333333,4.96666667 7.33333333,5.33333333 L7.33333333,7.33333333 L5.33333333,7.33333333 C4.96666667,7.33333333 4.66666667,7.63333333 4.66666667,8 C4.66666667,8.36666667 4.96666667,8.66666667 5.33333333,8.66666667 L7.33333333,8.66666667 L7.33333333,10.6666667 C7.33333333,11.0333333 7.63333333,11.3333333 8,11.3333333 C8.36666667,11.3333333 8.66666667,11.0333333 8.66666667,10.6666667 L8.66666667,8.66666667 L10.6666667,8.66666667 C11.0333333,8.66666667 11.3333333,8.36666667 11.3333333,8 C11.3333333,7.63333333 11.0333333,7.33333333 10.6666667,7.33333333 L8.66666667,7.33333333 L8.66666667,5.33333333 C8.66666667,4.96666667 8.36666667,4.66666667 8,4.66666667 Z M8,1.33333333 C4.32,1.33333333 1.33333333,4.32 1.33333333,8 C1.33333333,11.68 4.32,14.6666667 8,14.6666667 C11.68,14.6666667 14.6666667,11.68 14.6666667,8 C14.6666667,4.32 11.68,1.33333333 8,1.33333333 Z M8,13.3333333 C5.06,13.3333333 2.66666667,10.94 2.66666667,8 C2.66666667,5.06 5.06,2.66666667 8,2.66666667 C10.94,2.66666667 13.3333333,5.06 13.3333333,8 C13.3333333,10.94 10.94,13.3333333 8,13.3333333 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Side-Bar-/-Open-/-01-Add-Notes",
    transform: "translate(-334.000000, -558.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(333.000000, 557.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 16 0 16 16 0 16"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#297C78",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircleOutlineGreen);
export default __webpack_public_path__ + "static/media/add-circle-outline-green.e05be946e225a421b295e9d9509fe7f1.svg";
export { ForwardRef as ReactComponent };